<app-header [loggedUser]="loggedUser!"></app-header>
<router-outlet></router-outlet>
